
const TrailComponent = ({ setMaterial,trailsData,bikeColor, name, imgSrc, selected, onClick }) => {
  const Trail = trailsData.find((trailInfo) => trailInfo.name === name)?.component;

  return (
    <>
      {selected && Trail && <Trail setMaterial = {setMaterial} position={[0.2, 0.2, 1]} bikeColor={bikeColor} />}
    </>
  );
};

export default TrailComponent;